module.exports = __webpack_public_path__ + "static/media/leap-motion.9e19fe20.png";